// DEPENDENCIES
import _ from "lodash";

// COMPONENTS
import { SubFormDefinition } from "../../../../../../../../utils/forms/components/FormSet";

// STORE
import { SelectedGroupsByProgressive } from "../../../../../../models/SelectedGroupsByProgressive";
import {
    GROUP_TYPE,
    TerminalGroupConfiguration,
    GameGroupConfiguration
} from "../../../../../../reducers/editingConfiguration.reducer";

// UTILS
import groupListOfType from "../../../../../Utils/full-group-list";
import getSelectableCoins from "../../../../../Utils/GetSelectableCoins/get-selectable-coins";
import { parseAvailableGroups } from "../../../../../Utils/parse-available-groups";
import buildFormGridFields from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../../utils/forms/builders/build-schema-compliant-definition";

// CONTANTS AND DEFAULTS
import * as CONFIG_CONSTANTS from "../ProgressivesConfigurationSection.constants";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../../utils/utils";

export const normalSubforms = props =>
    _.memoize(
        ({
            terminalGroups,
            gameGroups,
            selectedTerminalGroups,
            selectedGameGroups,
            schema,
            selectedGroupType,
            progressivesConfig
        }): SubFormDefinition[] => {
            const coins = getSelectableCoins(props);

            return [
                _createNormalSubform(
                    schema,
                    terminalGroups,
                    gameGroups,
                    selectedTerminalGroups,
                    selectedGameGroups,
                    selectedGroupType,
                    progressivesConfig,
                    coins
                )
            ];
        }
    );

function _createNormalSubform(
    schema: any,
    terminalGroups: TerminalGroupConfiguration[],
    gameGroups: GameGroupConfiguration[],
    selectedTerminalGroups: SelectedGroupsByProgressive,
    selectedGameGroups: SelectedGroupsByProgressive,
    selectedGroupType: GROUP_TYPE,
    progressivesConfig,
    coins
): SubFormDefinition {
    const tempProgressiveSchema = schema.definitions.$normal_jackpot;

    const requiredGroupFields =
        selectedGroupType == null
            ? "groups_placeholder"
            : selectedGroupType == GROUP_TYPE.GAME
            ? "game_groups"
            : "terminal_groups";

    let progressiveSchema = {
        ...tempProgressiveSchema,
        required: [...tempProgressiveSchema.required, requiredGroupFields]
    };

    progressiveSchema.properties["id"]["unique"] = progressivesConfig.filter(progressive => progressive.type === "normal").map(progressive => progressive.id);

    if (selectedGroupType == null) {
        progressiveSchema.properties = {
            ...progressiveSchema.properties,
            [requiredGroupFields]: { type: "string" }
        };
    }

    const fullGroupList = groupListOfType(
        selectedGroupType,
        terminalGroups,
        gameGroups
    );

    const selectedGroupList = parseAvailableGroups(
        terminalGroups,
        selectedTerminalGroups,
        gameGroups,
        selectedGameGroups,
        "normal",
        selectedGroupType
    );

    const exclusiveFields = Object.keys(progressiveSchema.properties).filter(
        property => {
            return (
                progressiveSchema.properties[property].hasOwnProperty(
                    "exclusive"
                ) && progressiveSchema.properties[property].exclusive == true
            );
        }
    );

    const groupTypeFormDefinition = CONFIG_CONSTANTS.progressiveFormDefinition(
        selectedGroupType,
        coins,
        fullGroupList,
        selectedGroupList,
        [],
        undefined,
        undefined,
        exclusiveFields,
        undefined,
        'normal'
    );

    const formDefinition = buildSchemaCompliantDefinition(
        progressiveSchema,
        groupTypeFormDefinition,
        [
            CONFIG_CONSTANTS.SCHEMA_NAMES.ID,
            CONFIG_CONSTANTS.SCHEMA_NAMES.COIN,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GROUPS
        ]
    );

    return {
        formType: "normal",
        addLabel: "",
        emptyValue: defaultsNormal({
            schema: schema,
            progressivesConfig: progressivesConfig
        }),
        fields: buildFormGridFields(progressiveSchema, formDefinition, schema)
    };
}

const defaultsNormal = _.memoize(({ schema, progressivesConfig }) => {
    let defaults = {};
    defaults["terminal_groups"] = [];
    defaults["id"] = getNewGeneratedId("Normal", progressivesConfig);
    defaults["uuid"] = uuidv4();

    Object.keys(schema.definitions.$normal_jackpot.properties).map(item => {
        if (item !== "id" && item !== "uuid") {
            defaults[item] =
                checkRenderForProvider(
                    item,
                    schema.definitions.$normal_jackpot.properties
                ) && schema.definitions.$normal_jackpot.properties[item]
                    ? (schema.definitions.$normal_jackpot.properties[item]
                          .convert
                          ? schema.definitions.$normal_jackpot.properties[item]
                                .default / 100
                          : schema.definitions.$normal_jackpot.properties[item]
                                .default) ||
                      checkDefaultForType(
                          schema.definitions.$normal_jackpot.properties[item]
                              .type
                      )
                    : null;
        }
    });

    defaults["type"] = "normal";

    return defaults;
});
